// Module
var code = "<div ng-switch=\"vm.viewModelType\"> <div ng-switch-when=\"1\"> <wt-tag-name-display tag=\"vm.linkedViewModel\" is-edit-mode=\"vm.isEditMode\"></wt-tag-name-display> </div> <div ng-switch-when=\"2\"> <wt-identifier-name-display identifier=\"vm.linkedViewModel\" is-edit-mode=\"vm.isEditMode\"></wt-identifier-name-display> </div> </div>";
// Exports
module.exports = code;